import { methods } from "@linguaneo/rpc-contracts";
import { callRpcBrowser } from "../callRpcBrowser";
import type { AddBookmarkParams, AddBookmarkResult } from "./addBookmark";
import type {
  DeleteBookmarkParams,
  DeleteBookmarkResult,
} from "./deleteBookmark";
import type {
  GetBookmarkByWordParams,
  GetBookmarkByWordResult,
} from "./getBookmarkByWord";

export const addBookmarkClient = async (
  params: AddBookmarkParams
): Promise<AddBookmarkResult> => {
  return callRpcBrowser<AddBookmarkParams, AddBookmarkResult>(
    methods.users.bookmarks.add,
    params
  );
};

export const deleteBookmarkClient = async (
  params: DeleteBookmarkParams
): Promise<DeleteBookmarkResult> => {
  return callRpcBrowser<DeleteBookmarkParams, DeleteBookmarkResult>(
    methods.users.bookmarks.delete,
    params
  );
};

export const getBookmarkByWordClient = async (
  params: GetBookmarkByWordParams
): Promise<GetBookmarkByWordResult> => {
  return callRpcBrowser<GetBookmarkByWordParams, GetBookmarkByWordResult>(
    methods.users.bookmarks.byWord.get,
    params
  );
};
